import React, { useState } from 'react';
import axios from 'axios';
import SignaturePopup from './SignaturePopup';
import BASE_URL from '../../url';

const DocumentSignViewer = ({ signRequest, onSigned, onClose }) => {
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [signing, setSigning] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const pdfUrl = `${BASE_URL}${signRequest.filledPdfUrl}`;

  const handleApplySignature = async (signatureBase64) => {
    setShowSignaturePad(false);
    setSigning(true);
    setError('');

    try {
      const token = localStorage.getItem('supplierToken');
      const res = await axios.post(
        `${BASE_URL}/api/supplier-portal/sign/${signRequest.SignToken}`,
        { signatureBase64 },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSuccess('✅ Document signed successfully! A copy has been sent to the company.');
        setTimeout(() => { onSigned && onSigned(); }, 2500);
      } else {
        setError(res.data.message || 'Failed to sign document');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error submitting signature');
    } finally {
      setSigning(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
      padding: '20px'
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '900px',
        display: 'flex', flexDirection: 'column', maxHeight: '90vh',
        boxShadow: '0 25px 50px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#111827', display: 'flex', alignItems: 'center', gap: '8px' }}>
            📄 {signRequest.CompanyName} — {signRequest.TemplateType} Agreement
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#6b7280' }}>✕</button>
        </div>

        {/* Info bar */}
        <div style={{ background: '#fefce8', borderBottom: '1px solid #fde68a', padding: '10px 20px', fontSize: '13px', color: '#92400e', display: 'flex', gap: '24px', flexShrink: 0 }}>
          <span>⏰ Expires: <strong>{signRequest.ExpiresAtUtc ? new Date(signRequest.ExpiresAtUtc).toLocaleDateString() : 'N/A'}</strong></span>
          <span>📄 Type: <strong>{signRequest.TemplateType}</strong></span>
          <span>📅 Sent: <strong>{new Date(signRequest.CreatedAtUtc).toLocaleDateString()}</strong></span>
        </div>

        {/* PDF iframe */}
        <div style={{ flex: 1, position: 'relative', overflow: 'hidden', minHeight: '400px' }}>
          <iframe
            src={pdfUrl}
            title="Document to Sign"
            style={{ width: '100%', height: '100%', minHeight: '400px', border: 'none' }}
          />

          {/* Read-only overlay label */}
          <div style={{ position: 'absolute', top: '12px', right: '12px', background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', pointerEvents: 'none' }}>
            Read-only
          </div>

          {/* Signature zone overlay */}
          {!success && (
            <div
              onClick={() => !signing && setShowSignaturePad(true)}
              style={{
                position: 'absolute', bottom: '60px', left: '50%', transform: 'translateX(-50%)',
                background: 'rgba(59, 91, 253, 0.12)', border: '2px dashed #3b5bfd',
                borderRadius: '8px', padding: '12px 24px', cursor: signing ? 'wait' : 'pointer',
                display: 'flex', alignItems: 'center', gap: '8px', color: '#3b5bfd',
                fontWeight: '600', fontSize: '14px', backdropFilter: 'blur(4px)',
                boxShadow: '0 4px 12px rgba(1,157,136,0.2)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(-50%) scale(1.02)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(-50%) scale(1)'; }}
            >
              ✍️ {signing ? 'Submitting signature…' : 'Click here to sign this document'}
            </div>
          )}
        </div>

        {/* Status messages */}
        {error && <div style={{ padding: '12px 20px', background: '#fef2f2', color: '#ef4444', fontSize: '14px', borderTop: '1px solid #fecaca' }}>{error}</div>}
        {success && <div style={{ padding: '12px 20px', background: '#ecfdf5', color: '#065f46', fontSize: '14px', borderTop: '1px solid #6ee7b7', fontWeight: '600' }}>{success}</div>}

        {/* Footer */}
        {!success && (
          <div style={{ padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', color: '#6b7280', flexShrink: 0 }}>
            <span>📌 Please read the document fully before signing</span>
            <button onClick={onClose} style={{ padding: '6px 16px', borderRadius: '6px', border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>Close</button>
          </div>
        )}
      </div>

      {/* Signature canvas popup */}
      {showSignaturePad && (
        <SignaturePopup
          onApply={handleApplySignature}
          onClose={() => setShowSignaturePad(false)}
        />
      )}
    </div>
  );
};

export default DocumentSignViewer;
